(() => {
  const initialiseGallery = (root) => {
    if (!root || root.dataset.snGalleryReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('.product__media-item'));
    const controls = root.querySelectorAll('[data-sn-gallery-control]');
    if (!slides.length || !controls.length) return;

    root.dataset.snGalleryReady = 'true';
    let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const showSlide = (nextIndex) => {
      currentIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      const status = root.closest('media-gallery')?.querySelector('[role="status"]');
      if (status) status.textContent = `${currentIndex + 1} of ${slides.length}`;
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        const direction = control.dataset.snGalleryControl === 'next' ? 1 : -1;
        showSlide(currentIndex + direction);
      });
    });

    showSlide(currentIndex);
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-sn-featured-gallery]').forEach(initialiseGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
